import React from "react";

import { t } from "app/utils";

import QueryStringSwitch, { QueryStringSwitchState } from "components/filters/QueryStringSwitch";

const queryKey = "d";
const options = {
  future: t("Upcoming"),
  present: t("Ongoing"),
  past: t("Past")
};

const DateFilter = () => (
  <QueryStringSwitch
    clearLabel={t("All Events")}
    initialOpen
    options={options}
    queryKey={queryKey}
    title={t("Date")}
  />
);

export const DateFilterState = () => (
  <QueryStringSwitchState options={options} queryKey={queryKey} />
);

export default DateFilter;
